import { styled } from '@mui/material/styles';
import { keyframes } from '@emotion/react';
import { Table, TableRow, TableCell, FormControlLabel, Button, Typography } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const blink = keyframes({
  from: { opacity: 1 },
  to: { opacity: 0.2 }
});

const skeletonLoading = keyframes({
  '0%': { backgroundPosition: '-200px 0' },
  '100%': { backgroundPosition: 'calc(200px + 100%) 0' }
});

export const StyledTable = styled(Table, {
  shouldForwardProp: prop => prop !== 'loading'
})(({ loading }) => ({
  minWidth: '100%',
  '& thead': { position: 'relative' },
  '& th': { padding: '14px 14px 14px 22px', color: '#667' },
  '& td': { padding: '4px 4px 4px 22px' },
  ...(loading && {
    '& tbody tr': { filter: 'blur(5px)', height: 54 },
    '& tbody th, & tbody td': { animation: `${blink} 1.5s alternate infinite linear` }
  })
}));

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: prop => prop !== 'clickable' && prop !== 'skeleton'
})(({ clickable, skeleton }) => ({
  textDecoration: 'none',
  ...(clickable && { cursor: 'pointer' }),
  ...(skeleton && {
    height: 56,
    width: '100%',
    display: 'inline-block',
    margin: 6,
    borderRadius: 4,
    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
    backgroundSize: '200% 100%',
    animation: `${skeletonLoading} 1.5s linear infinite`,
    '&:nth-of-type(1)': { marginTop: 12 },
    '& td': { display: 'none' }
  })
}));

export const SettingsHeadCell = styled(TableCell)({
  position: 'relative',
  top: 4,
  padding: '0 !important',
  textAlign: 'right'
});

export const TableCustomizeCell = styled(TableCell)({
  position: 'absolute',
  top: 46,
  right: 0,
  backgroundColor: '#fff',
  zIndex: 1,
  boxShadow: '0px 2px 8px -1px rgba(0, 0, 0, 0.2), 0px 1px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
  borderRadius: 6,
  padding: '12px 24px'
});

export const CustomizeDialogTitle = styled(Typography)({
  fontWeight: 500,
  color: 'rgba(0, 0, 0, 0.87)',
  marginBottom: 6
});

export const OptionsCnt = styled('div')({
  display: 'flex',
  flexDirection: 'column'
});

export const ColumnOption = styled(FormControlLabel, {
  shouldForwardProp: prop => prop !== 'sorted'
})(({ sorted }) => ({
  color: 'rgba(0, 0, 0, 0.87)',
  width: '100%',
  ...(sorted && { width: 'auto', marginRight: 4 })
}));

export const OptionWrapper = styled('div', {
  shouldForwardProp: prop => prop !== 'sorted'
})(({ sorted }) => ({
  ...(sorted && {
    display: 'flex',
    alignItems: 'center',
    cursor: 'default'
  })
}));

export const StyledArrow = styled(ArrowUpwardIcon, {
  shouldForwardProp: prop => prop !== 'order'
})(({ order }) => ({
  fontSize: 20,
  transform: order === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)'
}));

export const ResetButton = styled(Button)(({ theme }) => ({
  left: theme.spacing(-1)
}));

export const ResetText = styled(Typography)({
  fontWeight: 500
});
